"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_OPTIONS = void 0;
exports.DEFAULT_OPTIONS = { useCache: true };
//# sourceMappingURL=data-entity.js.map